/**
 * Profile API calls.
 */

import { api } from './client.js';

export function getMyStats() {
  return api.get('/api/auth/me/stats');
}

export function updateProfile(fields) {
  return api.patch('/api/auth/me', fields);
}

export function changePassword(currentPassword, newPassword) {
  return api.post('/api/auth/me/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

// ── MFA / two-factor auth ──

// Begin enrollment: returns { secret, otpauth_uri, qr_code_base64 }.
export function setupMfa() {
  return api.post('/api/auth/mfa/setup');
}

// Complete enrollment by proving the authenticator works.
export function confirmMfa(code) {
  return api.post('/api/auth/mfa/confirm', { code });
}

// Turn MFA off — requires the account password.
export function disableMfa(password) {
  return api.post('/api/auth/mfa/disable', { password });
}
